var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg-icon',{attrs:{"icon-class":"github"},on:{"click":_vm.goto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }